/**
 *
 * Asynchronously loads the component for SupporterListPage
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
